<template>
  <PdfViewer :ref="viewerKey" />
</template>

<script>
import DocumentService from "@/services/DocumentService";
import PdfViewer from "@/components/document/PdfViewer";
import { EventBus } from "@/eventBus.js";

export default {
  name: "DocumentViewer",
  components: {
    PdfViewer,
  },
  data() {
    return {
      viewerKey: "documentListPdfViewer",
      documentId: 0,
      search: "",
    };
  },
  computed: {
    viewerInstance() {
      return this.$refs[this.viewerKey];
    },
  },
  methods: {
    loadDocument(documentId) {
      var self = this;
      DocumentService.canDisplay(documentId).then((canDisplay) => {
        let file = encodeURIComponent("/static/defaultDocument.pdf");

        if (canDisplay) {
          file = encodeURIComponent(DocumentService.display(documentId));
        }

        if (this.search) {
          file += "&#search=" + encodeURIComponent(this.search);
        }

        self.viewerInstance.load(file);
      });
    },
  },
  mounted() {
    EventBus.$on("loadDocument", (documentId) => {
      if (documentId != this.documentId) {
        this.documentId = documentId;
        this.loadDocument(documentId);
      }
    });
    EventBus.$on("loadDocument-with-search", (documentId, search) => {
      if (documentId != this.documentId) {
        this.documentId = documentId;
        this.search = search;
        this.loadDocument(documentId);
      }
    });
    EventBus.$on("cleanViewer", () => {
      let file = encodeURIComponent("/static/defaultDocument.pdf");
      this.viewerInstance.load(file);
    });
  },
  destroyed() {
    EventBus.$off("loadDocument");
    EventBus.$off("loadDocument-with-search");
    EventBus.$off("cleanViewer");
  },
};
</script>
